module.exports = __webpack_public_path__ + "static/media/p_3.2d600eb7.jpg";